import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { Queries } from 'apollo';

const useGetUserStatus = () => {
  const client = useApolloClient();
  const enrolled = useCallback(
    login =>
      client
        .query({
          query: Queries.getUserStatus,
          variables: { login },
        })
        .then(response => response.data.getUserStatus),
    [client],
  );
  return enrolled;
};

export default useGetUserStatus;
